export const Platform = {
	H5: 'h5'
}

export const PayType = {
	PAY_NEW: 'pay_new',
	O2O_ERRAND_PAY_NEW: 'o2o_errand_pay_new'
}
